import React, { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import PublicLayout from "./PublicLayout";
import DeepThinkersList from "./DeepThinkersList";
import { fetchShowcaseDeepThinkers } from "../service/ShowcaseService";

export default function ShowcaseDeepThinkers() {
    const navigate = useNavigate();
    const { key } = useParams();
    const [deepThinkers, setDeepThinkers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!key) return;
        fetchShowcaseDeepThinkers(key)
            .then(res => setDeepThinkers(res.deepThinkers ?? []))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [key]);

    return (
        <PublicLayout>
            <button className="chpw-back" onClick={() => navigate(`/showcase/${key}`)}>
                <ArrowLeft size={14} />
                Back to Showcase
            </button>

            <DeepThinkersList deepThinkers={deepThinkers} loading={loading} />
        </PublicLayout>
    );
}
